<div class="unit-intro-view h-full flex flex-col" data-testid="unit-intro-section">
  <!-- Header Bar -->
  <app-course-player-header
    [title]="currentItem.name"
    [currentIndex]="currentItemIndex"
    [totalItems]="totalItems"
    [canGoToPrevious]="canGoToPrevious"
    [canGoToNext]="canGoToNext"
    [showNavigation]="true"
    [showTimelineToggle]="true"
    [timelineVisible]="showTimeline"
    [showFullscreen]="showFullscreen"
    [isFullscreen]="isFullscreen"
    [showCloseButton]="true"
    [mode]="playerMode"
    (onNavigatePrevious)="onNavigatePrevious.emit()"
    (onNavigateNext)="onNavigateNext.emit()"
    (onTimelineToggle)="onTimelineToggle.emit()"
    (onFullscreenToggle)="onFullscreenToggle.emit()"
    (onClose)="onCloseModal.emit()">
  </app-course-player-header>

  <!-- Content
       KAN-676: the card is centred with `m-auto`, NOT `items-center justify-center`
       on this scroll container. Flex centring clips the TOP of a card taller than
       the container (a phone in landscape), and that part cannot be scrolled to;
       auto margins centre a short card the same way but drop to 0 on overflow.
       Padding and title size step down below `sm` so a 360px phone keeps its width. -->
  <div class="flex-1 overflow-y-auto flex p-4 sm:p-8 bg-base-200" data-testid="unit-intro-scroll">
    <div class="max-w-3xl w-full m-auto bg-base-100 rounded-lg shadow-lg p-4 sm:p-8" data-testid="unit-intro-card">
      <div class="text-center mb-6">
        <app-icon name="folder_open" size="xl" class="text-primary mb-4" aria-hidden="true"></app-icon>
        <h2 class="unit-intro-title text-2xl sm:text-3xl font-bold mb-2"
            [title]="currentItem.name"
            data-testid="unit-intro-title-heading">{{ currentItem.name }}</h2>
        @if (currentItem.description) {
          <p id="unit-intro-description"
             class="unit-intro-description text-base-content/70"
             [class.is-clamped]="!descriptionExpanded()"
             [appClampOverflow]="currentItem.description"
             (clampOverflowChange)="onDescriptionClampChange($event)"
             data-testid="unit-intro-description">
            {{ currentItem.description }}
          </p>
          @if (descriptionClamped()) {
            <button type="button"
              class="mx-auto mt-2 inline-flex items-center gap-1 px-2 py-1 text-sm text-primary hover:underline"
              (click)="toggleDescription()"
              [attr.aria-expanded]="descriptionExpanded()"
              aria-controls="unit-intro-description"
              data-testid="unit-intro-description-toggle">
              {{ descriptionExpanded() ? 'Show less' : 'Show more' }}
              <app-icon [name]="descriptionExpanded() ? 'expand_less' : 'expand_more'" size="sm" aria-hidden="true"></app-icon>
            </button>
          }
        }
      </div>

      <!-- Unit Stats
           KAN-676: stacked on phones; side by side (DaisyUI's default) the row
           scrolled sideways and cut off "Unit Quiz" at 360px. `sm:stats-horizontal`
           is a real rule here: the DaisyUI v4.12.10 CDN stylesheet ships the
           responsive stats variants inside its own @media (min-width:640px). -->
      @if (unitStats) {
        <div class="stats stats-vertical sm:stats-horizontal shadow w-full mb-6" data-testid="unit-intro-stats">
          <div class="stat place-items-center">
            <div class="stat-title">Modules in this Unit</div>
            <div class="stat-value text-primary">{{ unitStats.totalModules }}</div>
          </div>
          @if (unitStats.hasUnitQuiz) {
            <div class="stat place-items-center" data-testid="unit-intro-quiz-stat">
              <div class="stat-title">Unit Quiz</div>
              <div class="stat-value text-secondary">
                <app-icon name="quiz" size="lg" aria-hidden="true"></app-icon>
              </div>
              <div class="stat-desc">Ends with a quiz</div>
            </div>
          }
        </div>
      }

      <!-- KAN-326: locked-unit reason, shown inside the card so it is visible on
           the overview (the disabled Continue button below has no other cue). -->
      @if (lockReason) {
        <div class="alert alert-warning mb-4" role="alert" data-testid="unit-intro-lock-reason">
          <app-icon name="lock" size="sm" aria-hidden="true"></app-icon>
          <span>{{ lockReason }}</span>
        </div>
      }

      <!-- Continue Button -->
      <!-- KAN-676: stacked on phones, where side by side each button was ~130px
           wide and "Continue to First Module" wrapped with its arrow spilling out. -->
      <div class="flex flex-col sm:flex-row gap-3" role="navigation" aria-label="Unit navigation">
        <button class="btn btn-outline flex-1"
          (click)="onNavigatePrevious.emit()"
          [disabled]="!canGoToPrevious"
          aria-label="Go to previous item"
          data-testid="unit-intro-prev-btn">
          <app-icon name="arrow_back" size="sm" aria-hidden="true"></app-icon>
          Previous
        </button>
        <button class="btn btn-primary flex-1"
          (click)="onNavigateNext.emit()"
          [disabled]="!canGoToNext"
          aria-label="Continue to first module"
          data-testid="unit-intro-continue-btn">
          Continue to First Module
          <app-icon name="arrow_forward" size="sm" aria-hidden="true"></app-icon>
        </button>
      </div>

      <!-- KAN-370: live unit pass/fail verdict (KAN-314 VS2/VS3 readout) shown
           INSIDE the card so it is visible at all zoom levels; previously a
           sibling below this full-height component, clipped off-screen by the
           content-area's overflow:hidden. Self-guards when null/not_applicable. -->
      <div class="mt-6 text-center">
        <app-unit-pass-summary [result]="unitResult"></app-unit-pass-summary>
      </div>
    </div>
  </div>
</div>
